<script setup lang="ts">
import EventStatusName from '@desktop/views/Relation/components/RelationView/EventStatusName.vue'
import MainSummary from '@desktop/views/Relation/components/RelationView/Main/MainSummary/MainSummary.vue'
import ResultWithPopover from '@desktop/views/Relation/components/RelationView/Main/ResultWithPopover/ResultWithPopover.vue'
import SimpleEventClock from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/SimpleEventClock.vue'
import SummaryParticipantsImportantStats from '@desktop/views/Relation/Sports/components/RelationView/SummaryParticipantsImportantStats.vue'

import FormationsModal from './Formations/FormationsModal.vue'
import LineupsModal from './Lineups/LineupsModal.vue'
</script>

<template>
  <MainSummary
    :modalOptions="{
      skins: true,
      lineups: LineupsModal,
      formations: FormationsModal,
    }"
  >
    <template #result>
      <ResultWithPopover />
    </template>
    <template #bottom>
      <EventStatusName />
      <SummaryParticipantsImportantStats class="gap-x-4">
        <SimpleEventClock />
      </SummaryParticipantsImportantStats>
    </template>
  </MainSummary>
</template>
